import { useEffect, useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '../menu/Menu';
import Header from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Tabela from './tabela/Tabela';
import Filtro from '../filtros/Filtro';
import CampoPesquisa from '../pesquisa/CampoPesquisa';
import Botao from '../botao/Botao';
import ModalConfirmacao from '../modal/ModalConfirmacao';
import styled from 'styled-components';
import PontosService from '../../service/pontos';
import DesignacoesService from '../../service/designacao';
import ModalNovidades from './ModalNovidades';
import AvisoTradutor from './AvisoTradutor';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  margin-top: 85px;
  margin-bottom: 50px;

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`;

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 260px;
  /* Centraliza lógica de espaçamento horizontal para reutilização e consistência */
  --page-h-padding: clamp(20px, 4vw, 32px);
  --page-v-padding: clamp(20px, 3vh, 28px);
  padding: var(--page-v-padding) var(--page-h-padding) calc(var(--page-v-padding) * 0.75);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 1.5vh, 18px);

  @media (max-width: 1200px) and (min-width: 768px) {
    margin-left: 60px;
    --page-h-padding: 20px;
  }

  @media (max-width: 767px) {
    margin-left: 0;
    --page-h-padding: 16px;
    --page-v-padding: 16px;
    padding: var(--page-v-padding) var(--page-h-padding) 0;
    gap: 14px;
  }
`;

const FiltrosContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: clamp(12px, 1vw, 20px);
  margin: 0;
  padding: 0;

  @media (max-width: 1200px) and (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr auto;
    grid-template-areas:
      "label label label label"
      "ponto status search button";
    gap: 10px;
    align-items: center;
  }

  @media (max-width: 900px) {
    /* align-items: stretch;  <-- This might conflict with grid if ranges overlap. 
       900px is inside 1200px. 
       If display is grid, align-items works differently (aligns tracks or items in block axis).
       We want align-items: center for the grid items.
    */
  }

  @media (max-width: 767px) {
    display: flex; /* Reset to flex for mobile */
    flex-direction: column;
    gap: 12px;
    padding: 0;
    align-items: stretch;
  }
`;

const FiltrosEsquerda = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(12px, 1.5vw, 16px);
  flex-wrap: wrap;

  @media (max-width: 1200px) and (min-width: 768px) {
    display: contents;
  }

  @media (max-width: 1100px) {
    gap: 12px;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 10px;
    & > * { width: 100%; max-width: 100%; }
  }
`;

const FiltrosDireita = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(8px, 1vw, 12px);
  flex: 1;
  justify-content: flex-end;
  min-width: 280px;

  @media (max-width: 1200px) and (min-width: 768px) {
    display: contents;
  }

  @media (max-width: 1200px) {
    justify-content: flex-start;
  }

  @media (max-width: 900px) {
    min-width: 0;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
`;

const Label = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: clamp(14px, 1.2vw, 15px);
  color: #222;
  white-space: nowrap;

  @media (max-width: 1200px) and (min-width: 768px) {
    grid-area: label;
    width: 100%;
    margin-bottom: 0;
  }

  @media (max-width: 767px) {
    font-size: clamp(14px, 3.5vw, 16px);
    display: block;
    margin-bottom: 8px;
  }
`;

const StyledDropdown = styled.div`
  border: 1px solid #bdbdbd;
  border-radius: 24px;
  padding: 0 clamp(12px, 1.5vw, 15px);
  background: #fff;
  display: flex;
  align-items: center;
  min-width: fit-content;
  height: 44px;
  line-height: 44px;
  box-sizing: border-box;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 6px;
    height: 6px;
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
    margin-top: -3px;
    pointer-events: none;
  }

  & > select { 
    width:100%; 
    height:100%; 
    padding: 0 30px 0 8px; 
    font-size:15px; 
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    z-index: 1;
    cursor: pointer;
  }

  @media (max-width: 1400px) {
    min-width: clamp(200px, 30%, 280px);
  }

  @media (max-width: 1200px) and (min-width: 768px) {
    grid-area: status;
    width: 100%;
    min-width: 0;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 0 15px;
    min-width: 0;
  }
`;

const StyledDropdownPonto = styled.div`
  border: 1px solid #bdbdbd;
  border-radius: 24px;
  padding: 0 clamp(12px, 1.5vw, 15px);
  background: #fff;
  display: flex;
  align-items: center;
  min-width: fit-content;
  height: 44px;
  line-height: 44px;
  box-sizing: border-box;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 6px;
    height: 6px;
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
    margin-top: -3px;
    pointer-events: none;
  }

  & > select { 
    width:100%; 
    height:100%; 
    padding: 0 30px 0 8px; 
    font-size:15px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    z-index: 1;
    cursor: pointer;
  }

  @media (max-width: 1400px) {
    min-width: clamp(200px, 30%, 280px);
  }

  @media (max-width: 1200px) and (min-width: 768px) {
    grid-area: ponto;
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  @media (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 0 15px;
  }
`;

const SearchWrapper = styled.div`
  width: 280px;
  
  @media (max-width: 1200px) and (min-width: 768px) {
    width: 100%;
    grid-area: search;
  }
  
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ResponsiveBotao = styled(Botao)`
  flex: 0 0 auto;
  white-space: nowrap;
  height: 44px;
  margin-left: 0;

  @media (max-width: 1200px) and (min-width: 768px) {
    grid-area: button;
    width: 44px;
    padding: 0;
    margin-left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  @media (max-width: 767px) {
    width: 100%;
    margin-left: 0;
  }
`;

const ButtonText = styled.span`
  @media (max-width: 1200px) and (min-width: 768px) {
    display: none;
  }
`;

const IconeLixeira = styled.svg.attrs(() => ({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
  fill: 'none'
}))`
  width: 24px;
  height: 24px;
  display: none;
  
  path {
    stroke: #fff;
  }

  @media (max-width: 1200px) and (min-width: 768px) {
    display: block;
  }
`;

const TabelaWrapper = styled.div`
  flex: 1;
  overflow: visible;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 4px; /* reduz espaço extra entre filtros e tabela */

  @media (max-width: 767px) {
    margin-top: 2px;
  }
`;



const STATUS_LABELS = {
  Confirmado: 'Confirmado',
  Pendente: 'Pendente',
  Cancelado: 'Cancelado',
  Cancelado_Coordenador: 'Cancelado',
  Aguardando_Cancelamento: 'Cancelar designação'
};

const HomePage = () => {
  const navigate = useNavigate();

  const isSecretaria = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('perfilUsuario') || '[]').includes('secretaria');
    } catch {
      return false;
    }
  }, []);

  const [pontos, setPontos] = useState([]);
  const [pontoSelected, setPontoSelected] = useState('');
  const [status, setStatus] = useState('');
  const [pesquisa, setPesquisa] = useState('');
  const [designacoes, setDesignacoes] = useState([]);
  const [designacoesFiltradas, setDesignacoesFiltradas] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [itemParaExcluir, setItemParaExcluir] = useState(null);
  const [tipoExclusao, setTipoExclusao] = useState('individual'); 
  const [carregando, setCarregando] = useState(true);
  const [modalCancelarAberto, setModalCancelarAberto] = useState(false);
  const [designacaoParaCancelar, setDesignacaoParaCancelar] = useState(null);

  const ordenarPontos = (lista = []) => {
    return lista.slice().sort((a, b) => {
      const na = (a?.nome || '').toLocaleLowerCase('pt-BR');
      const nb = (b?.nome || '').toLocaleLowerCase('pt-BR');
      return na.localeCompare(nb, 'pt-BR', { sensitivity: 'base' });
    });
  };

  const fetchPontos = useCallback(() => {
    PontosService.getPontos(true)
      .then(response => {
        setPontos(ordenarPontos(response));
      })
      .catch(error => {
        console.error("Erro ao buscar pontos:", error);
      });
  }, []);

  const fetchDesignacoes = useCallback(() => {
    setCarregando(true);
    DesignacoesService.getDesignacoes(true)  
      .then(response => {
        setDesignacoes(response);
        setDesignacoesFiltradas(response);
      })
      .catch(error => {
        console.error("Erro ao buscar designações:", error);
      })
      .finally(() => {
        setCarregando(false);
      });
  }, []);

  useEffect(() => {
    fetchPontos();
    fetchDesignacoes();
  }, [fetchPontos, fetchDesignacoes]);

  const removerAcentuacao = (texto) => {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  // Replica exatamente a mesma lógica de obterStatusTabela do componente Tabela
  const obterStatusExibicao = (designacaoAtual) => {
    const statusGeral = designacaoAtual?.status;

    const statusIndividuais = (designacaoAtual?.publicadores || []).map(
      (publicador) => publicador?.statusIndividual || 'Pendente'
    );

    const totalPublicadores = statusIndividuais.length;

    const confirmados = statusIndividuais.filter(
      (status) => status === 'Confirmado'
    ).length;
    const cancelados = statusIndividuais.filter(
      (status) => status === 'Cancelado' || status === 'Cancelado_Coordenador'
    ).length;
    const pendentes = statusIndividuais.filter(
      (status) => status === 'Pendente'
    ).length;

    // REGRAS DE NEGÓCIO:

    // 1) Com 3 publicadores:
    //    - Se 2 ou mais cancelaram -> Cancelado (independente dos demais)
    //    - Se 2 ou mais confirmaram -> Confirmado (independente do terceiro)
    if (totalPublicadores === 3) {
      if (cancelados >= 2) {
        return 'Cancelado';
      }
      if (confirmados >= 2) {
        return 'Confirmado';
      }
      // Se apenas 1 confirmou e 1 cancelou (1 pendente) -> Pendente
      if (confirmados === 1 && cancelados === 1 && pendentes === 1) {
        return 'Pendente';
      }
      // Demais casos (ex: todos pendentes, 1 confirmado e 2 pendentes, etc.) -> Pendente
      return 'Pendente';
    }

    // 2) Com 2 publicadores:
    //    - Se ambos confirmaram -> Confirmado
    //    - Se ambos cancelaram -> Cancelado
    //    - Se um confirmou e outro cancelou/pendente -> Cancelado
    //    - Se nenhum confirmou -> Pendente
    if (totalPublicadores === 2) {
      if (confirmados === 2) {
        return 'Confirmado';
      }
      if (cancelados >= 1) {
        return 'Cancelado';
      }
      // Ambos pendentes
      return 'Pendente';
    }

    // 3) Fallback para outros casos (1 publicador ou > 3):
    //    - Todos cancelaram -> Cancelado
    //    - Pelo menos 2 confirmaram -> Confirmado
    //    - 1 confirmado e os demais cancelaram -> Aguardando_Cancelamento
    //    - Caso contrário -> Pendente
    if (totalPublicadores > 0 && cancelados === totalPublicadores) {
      return 'Cancelado';
    }

    if (confirmados >= 2) {
      return 'Confirmado';
    }

    if (confirmados === 1 && cancelados >= 1 && pendentes === 0) {
      return 'Aguardando_Cancelamento';
    }

    // Se status geral for válido, usa ele como fallback
    if (
      [
        'Cancelado_Coordenador',
        'Cancelado',
        'Confirmado',
        'Aguardando_Cancelamento',
        'Pendente',
      ].includes(statusGeral)
    ) {
      return statusGeral;
    }

    return 'Pendente';
  };

  const aplicarFiltros = () => {
    let designacoesFilt = [...designacoes];

    if (pontoSelected) {
      designacoesFilt = designacoesFilt.filter(designacao => 
        designacao?.ponto?.nome === pontoSelected
      );
    }

    if (status) {
      designacoesFilt = designacoesFilt.filter(designacao => {
        const statusExibicao = obterStatusExibicao(designacao);
        
        if (status === 'Cancelado') {
          return statusExibicao === 'Cancelado' || statusExibicao === 'Cancelado_Coordenador';
        }
        if (status === 'Cancelar designação') {
          return statusExibicao === 'Aguardando_Cancelamento';
        }
        return statusExibicao === status;
      });
    }

    if (pesquisa) {
      designacoesFilt = designacoesFilt.filter(designacao => {
        const searchTerm = removerAcentuacao(pesquisa.toLowerCase());
        const statusExibicao = obterStatusExibicao(designacao);
        const statusDisplay = removerAcentuacao((STATUS_LABELS[statusExibicao] || statusExibicao || '').toLowerCase());
        const pontoNome = removerAcentuacao((designacao?.ponto?.nome || '').toLowerCase());
        const pontoLocal = removerAcentuacao((designacao?.ponto?.local || '').toLowerCase());
        const statusNome = removerAcentuacao((statusExibicao || '').toLowerCase());
        const dataRaw = designacao?.data ? String(designacao.data).substring(0, 10) : '';
        const [dYear, dMonth, dDay] = dataRaw ? dataRaw.split('-').map(Number) : [0, 0, 0];
        const dataFormatada = dataRaw ? `${String(dDay).padStart(2,'0')}/${String(dMonth).padStart(2,'0')}/${dYear}` : '';
        
        return (
          pontoNome.includes(searchTerm) ||
          pontoLocal.includes(searchTerm) ||
          statusNome.includes(searchTerm) ||
          statusDisplay.includes(searchTerm) ||
          dataFormatada.includes(searchTerm) ||
          designacao?.publicadores?.some(pub => {
            const pubNome = removerAcentuacao((pub?.nome || '').toLowerCase());
            const pubEmail = removerAcentuacao((pub?.email || '').toLowerCase());
            const pubCongregacao = removerAcentuacao((pub?.congregacao?.nome || '').toLowerCase());
            return pubNome.includes(searchTerm) || 
                   pubEmail.includes(searchTerm) || 
                   pubCongregacao.includes(searchTerm);
          })
        );
      });
    }

    setDesignacoesFiltradas(designacoesFilt);
  };

  const excluirDesignacao = async (id) => {
    try {
      await DesignacoesService.deleteDesignacao(id);
      // Atualiza estado local removendo a designação excluída
      setDesignacoes(prev => prev.filter(d => d._id !== id));
      setSelectedItems(prev => prev.filter(item => item !== id));
      setModalAberto(false);
      setItemParaExcluir(null);
    } catch (error) {
      console.error("Erro ao excluir designação:", error);
    }
  };

  const excluirSelecionados = async () => {
    try {
      const idsParaExcluir = [...selectedItems];
      for (const id of idsParaExcluir) {
        await DesignacoesService.deleteDesignacao(id);
      }
      // Atualiza estado local removendo todas as designações excluídas
      setDesignacoes(prev => prev.filter(d => !idsParaExcluir.includes(d._id)));
      setSelectedItems([]);
      setSelectAll(false);
      setModalAberto(false);
    } catch (error) {
      console.error("Erro ao excluir designações selecionadas:", error);
    }
  };

  const confirmarCancelamentoDesignacao = (designacao) => {
    setDesignacaoParaCancelar(designacao);
    setModalCancelarAberto(true);
  };

  const executarCancelamentoCoordenador = async () => {
    if (!designacaoParaCancelar?._id) return;

    try {
      await DesignacoesService.cancelarDesignacaoCoordenador(designacaoParaCancelar._id);
      // Recarrega apenas as designações após cancelamento do coordenador
      fetchDesignacoes();
    } catch (error) {
      console.error("Erro ao cancelar designação pelo coordenador:", error);
    } finally {
      setDesignacaoParaCancelar(null);
      setModalCancelarAberto(false);
    }
  };

  const fecharModalCancelar = () => {
    setModalCancelarAberto(false);
    setDesignacaoParaCancelar(null);
  };

  const confirmarExclusaoIndividual = (id) => {
    setItemParaExcluir(id);
    setTipoExclusao('individual');
    setModalAberto(true);
  };

  const confirmarExclusaoMultipla = () => {
    setTipoExclusao('multipla');
    setModalAberto(true);
  };

  const executarExclusao = () => {
    if (tipoExclusao === 'individual') {
      excluirDesignacao(itemParaExcluir);
    } else {
      excluirSelecionados();
    }
  };

  const fecharModal = () => {
    setModalAberto(false);
    setItemParaExcluir(null);
  };

  const handleSelectItem = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter(item => item !== id));
      setSelectAll(false);
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
    } else {
      setSelectedItems(designacoesFiltradas?.map(d => d._id));
      setSelectAll(true);
    }
  };

  useEffect(() => {
    aplicarFiltros();
  }, [pontoSelected, status, pesquisa, designacoes]);

  return (
    <PageWrapper>
      <Header />
      <Menu />
      <MainContentWrapper>
        <Container>
          <FiltrosContainer>
            <FiltrosEsquerda>
              <Label>Filtrar por:</Label>
              <StyledDropdownPonto>
                <Filtro
                  options={pontos?.map(ponto => ponto?.nome)}
                  onSelect={setPontoSelected}
                  label={'Ponto'}
                  fixedWidth={true}
                  value={pontoSelected}
                />
              </StyledDropdownPonto>
              <StyledDropdown>
                <Filtro
                  options={['Confirmado', 'Pendente', 'Cancelado']}
                  onSelect={setStatus}
                  label={'Status'}
                  value={status}
                />
              </StyledDropdown>
            </FiltrosEsquerda>
            <FiltrosDireita>
              <SearchWrapper>
                <CampoPesquisa
                  value={pesquisa}
                  onChange={e => setPesquisa(e.target.value)}
                  placeholder="Pesquisar"
                />
              </SearchWrapper>
              <ResponsiveBotao 
                onClick={confirmarExclusaoMultipla} 
                disabled={isSecretaria || selectedItems.length === 0}
                style={{ cursor: isSecretaria ? 'not-allowed' : (selectedItems.length === 0 ? 'not-allowed' : 'pointer'), opacity: isSecretaria ? 0.5 : 1 }}
                title={isSecretaria ? 'Perfil de acesso não pode excluir designações' : ''}
              >
                <ButtonText>EXCLUIR</ButtonText>
                <IconeLixeira>
                  <path
                    d='M5.33337 9.33334H26.6667'
                    strokeWidth='1.57'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M13.3333 14.6667V22.6667'
                    strokeWidth='1.57'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M18.6667 14.6667V22.6667'
                    strokeWidth='1.57'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M6.66675 9.33334L8.00008 25.3333C8.00008 26.0406 8.28103 26.7189 8.78113 27.219C9.28123 27.7191 9.9595 28 10.6667 28H21.3334C22.0407 28 22.7189 27.7191 23.219 27.219C23.7191 26.7189 24.0001 26.0406 24.0001 25.3333L25.3334 9.33334'
                    strokeWidth='1.57'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M12 9.33333V5.33333C12 4.97971 12.1405 4.64057 12.3905 4.39052C12.6406 4.14048 12.9797 4 13.3333 4H18.6667C19.0203 4 19.3594 4.14048 19.6095 4.39052C19.8595 4.64057 20 4.97971 20 5.33333V9.33333'
                    strokeWidth='1.57'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </IconeLixeira>
              </ResponsiveBotao>
            </FiltrosDireita>
          </FiltrosContainer>
          <TabelaWrapper>
            <Tabela 
              designacoes={designacoesFiltradas} 
              selectedItems={selectedItems}
              selectAll={selectAll}
              onSelectItem={handleSelectItem}
              onSelectAll={handleSelectAll}
              onDelete={confirmarExclusaoIndividual}
              onRequestCancelamento={confirmarCancelamentoDesignacao}
              carregando={carregando}
              onRefresh={fetchDesignacoes}
            />
          </TabelaWrapper>
        </Container>
      </MainContentWrapper>
      <ModalConfirmacao
        isOpen={modalAberto}
        onClose={fecharModal}
        onConfirm={executarExclusao}
        titulo="Confirmar Exclusão"
        mensagem={
          tipoExclusao === 'individual'
            ? "Deseja confirmar a exclusão da designação?"
            : selectedItems.length === 1
            ? `Deseja confirmar a exclusão de ${selectedItems.length} designação selecionada?`
            : `Deseja confirmar a exclusão de ${selectedItems.length} designações selecionadas?`
        }
      />
      <ModalConfirmacao
        isOpen={modalCancelarAberto}
        onClose={fecharModalCancelar}
        onConfirm={executarCancelamentoCoordenador}
        titulo="Cancelar designação"
        mensagem="Confirma cancelar esta designação? Todos os publicadores serão notificados de que a designação foi cancelada pelo coordenador."
      />
      
      {/* <ModalNovidades /> */}
      <AvisoTradutor />

      <Rodape />
    </PageWrapper>
  );
};

export default HomePage;
